var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import Select from "@irati/ui/src/FormItem/Select";
import { canModifyUserMembership } from "@irati/identity/utils/team/membership";
import authentication from "@irati/auth";
import { injectIntl } from "@irati/utils/lang";
import businessService from "@irati/identity/services/business";
import userService from "@irati/identity/services/users";
var Roles;
(function (Roles) {
    Roles["User"] = "user";
    Roles["Manager"] = "manager";
    Roles["Admin"] = "admin";
})(Roles || (Roles = {}));
var EditUserRole = function (_a) {
    var formatMessage = _a.formatMessage, team = _a.team, user = _a.user, onChange = _a.onChange;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(Roles.User), role = _c[0], setRole = _c[1];
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    useEffect(function () {
        setRole(user.role);
        setOptions(makeOptions(formatMessage, team, user));
    }, []);
    var handleChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var teamId, business;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setRole(value);
                    teamId = (team === null || team === void 0 ? void 0 : team.uuid) || "";
                    if (!!teamId) return [3 /*break*/, 2];
                    return [4 /*yield*/, businessService.get({ businessId: user.businessId || user.tenant })];
                case 1:
                    business = _a.sent();
                    teamId = business.rootTeamId;
                    _a.label = 2;
                case 2: return [4 /*yield*/, makeRoleChange(teamId, user.uuid, value)];
                case 3:
                    _a.sent();
                    if (!onChange) return [3 /*break*/, 5];
                    return [4 /*yield*/, onChange()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var normalisedRole = role === "super-admin" ? Roles.Admin : role;
    return (React.createElement(Select, { label: "admin.components.userProfilePopUp.form.fields.select.label", value: normalisedRole, options: options, isSearchable: false, isClearable: false, isLoading: loading, name: "rolesSelect", onChange: handleChange }));
};
export default injectIntl(EditUserRole);
function makeOptions(formatMessage, team, user) {
    var arr = [{ value: Roles.User, label: formatMessage({ id: "admin.roles.user" }) }];
    if (!team) {
        arr.push({ value: Roles.Manager, label: formatMessage({ id: "admin.roles.manager" }) });
        if (authentication.isGlobalAdmin() || authentication.isUserGhost()) {
            arr.push({ value: Roles.Admin, label: formatMessage({ id: "admin.roles.admin" }) });
        }
    }
    else if (canModifyUserMembership(team, authentication.user(), user)) {
        arr.push({ value: Roles.Manager, label: formatMessage({ id: "admin.roles.manager" }) });
        if (authentication.isGlobalAdmin() || authentication.isUserGhost()) {
            arr.push({ value: Roles.Admin, label: formatMessage({ id: "admin.roles.admin" }) });
        }
    }
    return arr;
}
function makeRoleChange(teamId, userId, role) {
    if (role === Roles.User) {
        return userService.makeUserBasic(teamId, userId);
    }
    else if (role === Roles.Manager) {
        return userService.makeUserManager(teamId, userId);
    }
    else {
        return userService.makeUserGlobalAdmin(userId);
    }
}
